import { Button, Badge } from "@/components/common";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const MainHeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-white">
      {/* 전체 컨테이너*/}
      <div className="relative pb-10 mx-auto max-w-[1200px] sm:pt-15 sm:pb-15 wide:px-0 px-[2rem]">
        {/* 내부 요소 컨테이너 */}
        <div className="flex flex-col-reverse about:flex-row items-center justify-between gap-16 wide:gap-4">
          {/* [중앙 메인 카피 영역] */}
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="flex-1 flex flex-col text-center  items-center about:items-start about:text-left"
          >
            <h1 className="text-[3.2rem] sm:text-[4rem] md:text-[4.8rem] wide:text-[5.8rem] font-extrabold leading-[1.18] tracking-[-0.04em] text-[#20273a] break-keep text-center about:text-left">
              모든 고객 소통을 <br /> 더{" "}
              <span className="bg-gradient-to-r from-[#0052CC] to-[#9EA0FD] bg-clip-text text-transparent">
                빠르게
              </span>
              , 더{" "}
              <span className="bg-gradient-to-r from-[#0052CC] to-[#9EA0FD] bg-clip-text text-transparent">
                스마트하게
              </span>
            </h1>

            <p className="my-6 text-[1.6rem] leading-[1.4] text-[#475569] sm:text-[2rem] font-medium ">
              메시징과 문자콜센터를 하나로 연결해 <br />
              상담부터 발송까지 끊김 없는 고객 경험을 제공합니다.
            </p>

            <div className="flex flex-col gap-3 mt-4 sm:flex-row sm:items-center justify-center about:justify-start w-full">
              {/* 서비스 문의 버튼 */}
              <Link
                to="/voc/submit"
                className="flex items-center justify-center rounded-[1.2rem] px-[2.8rem] py-[1.8rem] text-[1.8rem] font-semibold text-white shadow-lg transition-transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-[#0052CC] focus:ring-offset-2"
                style={{
                  background: "linear-gradient(135deg, #246FF3 0%, #1A6FE8 50%, #4D8CFF 100%)",
                }}
              >
                {/* Material Icon: chat */}
                <span className="material-icons-round mr-[1rem] text-[2.2rem]">chat</span>
                서비스 문의
                <span className="flex items-center ml-[1.2rem]">
                  <span className="material-icons-round text-[2rem] font-light">arrow_forward</span>
                </span>
              </Link>

              {/* 회사 소개서 받기 버튼  */}
              <a
                href="/file/std_company_info.pdf"
                download="회사소개서.pdf"
                className="flex items-center justify-center rounded-[1.2rem] border border-[#E0E6ED] bg-white px-[2.8rem] py-[1.8rem] text-[1.8rem] font-semibold text-[#0052CC] shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#0052CC] focus:ring-offset-2"
              >
                <span className="material-icons-round mr-[1rem] text-[2.2rem]">description</span>
                회사 소개서 받기
                <span className="flex items-center ml-[1.2rem]">
                  <span className="material-icons-round text-[2rem] font-light">arrow_forward</span>
                </span>
              </a>
            </div>
          </motion.div>
          {/* [우측 오브젝트] */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="w-[40rem] shrink-0 relative top-10 wide:w-[60rem] pr-[4rem]"
          >
            <img
              src="/img/main/main_webcall_01.png"
              alt="우측 핸드폰"
              className="w-full object-contain drop-shadow-[0_18px_40px_rgba(27,88,177,0.18)]"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MainHeroSection;
